import React, { useState } from "react";
import { getSortedFields, getFieldDisplayName, searchFields } from "../utils/fieldMapping";

const FilterBuilder = ({ fieldMetadata, filters, onChange }) => {
  const [newFilter, setNewFilter] = useState({
    field: '',
    operator: 'equals',
    value: '',
    minValue: '',
    maxValue: '',
    startIndex: 0,
    length: 4
  });
  const [fieldSearchQuery, setFieldSearchQuery] = useState('');

  const operators = {
    string: [
      { value: 'equals', label: 'Равно' },
      { value: 'contains', label: 'Содержит' },
      { value: 'startsWith', label: 'Начинается с' },
      { value: 'endsWith', label: 'Заканчивается на' },
      { value: 'substring', label: 'Подстрока (по позиции)' },
      { value: 'isEmpty', label: 'Пустое значение' },
      { value: 'isNotEmpty', label: 'Не пустое значение' }
    ],
    number: [
      { value: 'equals', label: 'Равно' },
      { value: 'greaterThan', label: 'Больше' },
      { value: 'lessThan', label: 'Меньше' },
      { value: 'between', label: 'Между' },
      { value: 'isEmpty', label: 'Пустое значение' },
      { value: 'isNotEmpty', label: 'Не пустое значение' }
    ],
    date: [
      { value: 'equals', label: 'Равно' },
      { value: 'greaterThan', label: 'Позже' },
      { value: 'lessThan', label: 'Раньше' },
      { value: 'between', label: 'Между' }
    ],
    select: [
      { value: 'equals', label: 'Равно' },
      { value: 'contains', label: 'Содержит' }
    ]
  };

  // Расширенный список fallback полей для фильтрации
  const fallbackFields = [
    // Основные поля
    { value: 'id', label: 'ID', type: 'number' },
    { value: 'title', label: 'Название', type: 'string' },
    { value: 'opportunity', label: 'Сумма', type: 'number' },
    { value: 'createdTime', label: 'Дата создания', type: 'date' },
    { value: 'updatedTime', label: 'Дата изменения', type: 'date' },
    { value: 'stageId', label: 'Стадия', type: 'select' },
    { value: 'assignedById', label: 'Ответственный', type: 'number' },
    { value: 'createdBy', label: 'Кто создал', type: 'number' },
    { value: 'companyId', label: 'Компания', type: 'number' },
    { value: 'contactId', label: 'Контакт', type: 'number' },

    // Пользовательские поля
    { value: 'ufCrm3_1746789101', label: 'Номер заказа', type: 'string' },
    { value: 'ufCrm3_1746789474', label: 'ID-Франчайзи', type: 'string' },
    { value: 'ufCrm3_1746789363', label: 'Размер стекла', type: 'string' },
    { value: 'ufCrm3_1746789446', label: 'Толщина стекла', type: 'string' },
    { value: 'ufCrm3_1746789468', label: 'Тип стекла', type: 'string' },
    { value: 'ufCrm3_1746789572', label: 'Обработка', type: 'string' },
    { value: 'ufCrm3_1746789589', label: 'Количество', type: 'number' },
    { value: 'ufCrm3_1746789599', label: 'Цена за единицу', type: 'number' },
    { value: 'ufCrm3_1746789627', label: 'Общая стоимость', type: 'number' },
    { value: 'ufCrm3_1746789650', label: 'Статус оплаты', type: 'string' },
    { value: 'ufCrm3_1746789862', label: 'Комментарий', type: 'string' },
    { value: 'ufCrm3_1746789890', label: 'Дата доставки', type: 'date' },
    { value: 'ufCrm3_1746789910', label: 'Адрес доставки', type: 'string' },
    { value: 'ufCrm3_1746790033', label: 'Контактное лицо', type: 'string' },
    { value: 'ufCrm3_1746790136', label: 'Телефон', type: 'string' }
  ];

  const getAvailableFields = () => {
    console.log('FilterBuilder - fieldMetadata:', fieldMetadata);
    console.log('FilterBuilder - fieldMetadata keys count:', Object.keys(fieldMetadata || {}).length);

    // Получаем все поля из маппинга с учетом поиска
    const foundFields = fieldSearchQuery ? searchFields(fieldSearchQuery) : getSortedFields();
    const mappedFields = foundFields.map(field => ({
      value: field.id,
      label: field.name,
      type: getFieldTypeFromMapping(field.id)
    }));

    console.log('FilterBuilder - поля из маппинга:', mappedFields.length);
    return mappedFields;
  };

  // Определяем тип поля на основе его ID и названия
  const getFieldTypeFromMapping = (fieldId) => {
    const dateFields = [
      'createdTime', 'updatedTime',
      'ufCrm3_1749213244986', 'ufCrm3_1749213350972', 'ufCrm3_1749555592378'
    ];

    const fileFields = [
      'ufCrm3_1746789862', 'ufCrm3_1746789890', 'ufCrm3_1746789910',
      'ufCrm3_1746790033', 'ufCrm3_1746790136', 'ufCrm3_1749213221666',
      'ufCrm3_1749213340553', 'ufCrm3_1749213376934', 'ufCrm3_1749475648149',
      'ufCrm3_1753795707997', 'ufCrm3_1754046893462', 'ufCrm3_1757005830'
    ];

    const numberFields = [
      'id', 'assignedById', 'opportunity', 'companyId', 'contactId', 'createdBy'
    ];

    if (dateFields.includes(fieldId)) return 'date';
    if (fileFields.includes(fieldId)) return 'file';
    if (numberFields.includes(fieldId)) return 'number';
    return 'string';
  };

  const getOperatorsForField = (fieldKey) => {
    const fieldType = getFieldTypeFromMapping(fieldKey);
    return operators[fieldType] || operators.string;
  };

  const getFieldType = (fieldKey) => {
    return getFieldTypeFromMapping(fieldKey);
  };

  const addFilter = () => {
    if (!newFilter.field) {
      alert('Пожалуйста, выберите поле для фильтрации');
      return;
    }

    const filterToAdd = {
      id: Date.now(),
      ...newFilter
    };

    onChange([...filters, filterToAdd]);

    setNewFilter({
      field: '',
      operator: 'equals',
      value: '',
      minValue: '',
      maxValue: '',
      startIndex: 0,
      length: 4
    });
  };

  const removeFilter = (filterId) => {
    onChange(filters.filter(f => f.id !== filterId));
  };

  const updateFilter = (filterId, updates) => {
    onChange(filters.map(f => f.id === filterId ? { ...f, ...updates } : f));
  };

  const getFilterDescription = (filter) => {
    const field = getAvailableFields().find(f => f.value === filter.field);
    const operator = getOperatorsForField(filter.field).find(op => op.value === filter.operator);

    if (!field || !operator) return '';

    let description = `${field.label} ${operator.label.toLowerCase()}`;

    switch (filter.operator) {
      case 'between':
        description += ` ${filter.minValue} и ${filter.maxValue}`;
        break;
      case 'substring':
        description += ` с позиции ${filter.startIndex}, длина ${filter.length}: "${filter.value}"`;
        break;
      case 'isEmpty':
      case 'isNotEmpty':
        break;
      default:
        description += ` "${filter.value}"`;
    }

    return description;
  };

  const availableFields = getAvailableFields();

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Настройка фильтров</h3>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start space-x-2">
          <div>
            <h4 className="text-blue-900 font-medium">Фильтры данных</h4>
            <p className="text-blue-700 text-sm mt-1">
              Добавьте условия для отбора данных. Например, для франчайзи можно фильтровать по ID франчайзи или использовать подстроку для группировки по первым символам.
            </p>
          </div>
        </div>
      </div>

      {filters.length > 0 && (
        <div className="space-y-3">
          <h4 className="font-medium text-gray-900">Активные фильтры ({filters.length})</h4>
          {filters.map((filter) => (
            <div key={filter.id} className="bg-gray-50 border rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="text-sm font-medium text-gray-900">
                  {getFilterDescription(filter)}
                </div>
                <button
                  onClick={() => removeFilter(filter.id)}
                  className="text-red-600 hover:text-red-800 text-sm font-medium"
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6">
        <h4 className="font-medium text-gray-900 mb-4">Добавить новый фильтр</h4>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Поле для фильтрации
            </label>
            <div className="space-y-2">
              <input
                type="text"
                value={fieldSearchQuery}
                onChange={(e) => setFieldSearchQuery(e.target.value)}
                placeholder="Поиск полей..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
              <select
                value={newFilter.field}
                onChange={(e) => setNewFilter({...newFilter, field: e.target.value, operator: 'equals'})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Выберите поле</option>
                {availableFields.map((field) => (
                  <option key={field.value} value={field.value}>
                    {field.label}
                  </option>
                ))}
              </select>
              {fieldSearchQuery && (
                <div className="text-xs text-gray-500">
                  Найдено полей: {availableFields.length}
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Условие
            </label>
            <select
              value={newFilter.operator}
              onChange={(e) => setNewFilter({...newFilter, operator: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={!newFilter.field}
            >
              {getOperatorsForField(newFilter.field).map((op) => (
                <option key={op.value} value={op.value}>
                  {op.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Значение
            </label>
            {newFilter.operator === 'substring' ? (
              <div className="space-y-2">
                <input
                  type="text"
                  value={newFilter.value}
                  onChange={(e) => setNewFilter({...newFilter, value: e.target.value})}
                  placeholder="Ожидаемая подстрока"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <div className="flex space-x-2">
                  <input
                    type="number"
                    value={newFilter.startIndex}
                    onChange={(e) => setNewFilter({...newFilter, startIndex: parseInt(e.target.value) || 0})}
                    placeholder="Позиция"
                    className="w-1/2 px-3 py-2 border border-gray-300 rounded-md"
                  />
                  <input
                    type="number"
                    value={newFilter.length}
                    onChange={(e) => setNewFilter({...newFilter, length: parseInt(e.target.value) || 1})}
                    placeholder="Длина"
                    className="w-1/2 px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
              </div>
            ) : !['isEmpty', 'isNotEmpty'].includes(newFilter.operator) ? (
              <input
                type="text"
                value={newFilter.value}
                onChange={(e) => setNewFilter({...newFilter, value: e.target.value})}
                placeholder="Введите значение"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            ) : (
              <div className="text-sm text-gray-500 py-2 px-3 bg-gray-100 rounded-md">
                Значение не требуется
              </div>
            )}
          </div>
        </div>

        <div className="mt-4">
          <button
            onClick={addFilter}
            disabled={!newFilter.field}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors"
          >
            + Добавить фильтр
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBuilder;